module.exports = __webpack_public_path__ + "static/img/admission-test.272f5905.png";